<script lang="ts" setup>
import { FormContextKey } from 'vee-validate'
import { computed, inject } from 'vue'
import { useFormField } from './useFormField'

const { formMessageId, error, isTouched } = useFormField()
const form = inject(FormContextKey, undefined)

const message = computed(() => {
  if (!error.value) return undefined
  if (isTouched.value || (form?.submitCount.value ?? 0) > 0) {
    return error.value
  }
  return undefined
})
</script>

<template>
  <p
    v-if="message"
    :id="formMessageId"
    role="alert"
    class="text-sm font-medium text-destructive"
  >
    {{ message }}
  </p>
</template>
